/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import {
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  GET_COUNTS_REQUEST,
  GET_COUNTS_SUCCESS,
  GET_COUNTS_FAILURE,
  GET_HP_REQUEST,
  GET_HP_SUCCESS,
  GET_HP_FAILURE,
  PROFILE_DATA,
  COMPANY_DATA,
  GET_PROFILE,
  GET_COMPANY,
  MFA_PENDING,
  MFA_COMPLETE,
} from "./action-types";

export const signIn = (requestData, onSuccess, onError) => ({
  type: SIGN_IN_REQUEST,
  payload: requestData,
  meta: {
    onSuccess,
    onError,
  },
});

export const signInSuccess = (responseData) => ({
  type: SIGN_IN_SUCCESS,
  payload: responseData,
});

export const signInError = (error) => ({
  type: SIGN_IN_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT_REQUEST,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const logoutError = (error) => ({
  type: LOGOUT_FAILURE,
  payload: error,
});

export const getCounts = () => ({
  type: GET_COUNTS_REQUEST,
});

export const getCountsSuccess = (responseData) => ({
  type: GET_COUNTS_SUCCESS,
  payload: responseData,
});

export const getCountsError = (error) => ({
  type: GET_COUNTS_FAILURE,
  payload: error,
});

export const getHp = () => ({
  type: GET_HP_REQUEST,
});

export const getHpSuccess = (responseData) => ({
  type: GET_HP_SUCCESS,
  payload: responseData,
});

export const getHpError = (error) => ({
  type: GET_HP_FAILURE,
  payload: error,
});

export const getProfile = () => ({
  type: GET_PROFILE,
});

export const getCompany = () => ({
  type: GET_COMPANY,
});

export const profileData = (payload) => ({
  type: PROFILE_DATA,
  payload,
});

export const companyData = (payload) => ({
  type: COMPANY_DATA,
  payload,
});

/** Dispatched when login succeeds but MFA verification is still required. */
export const mfaPending = ({ preAuthToken, mfaEnrolled }) => ({
  type: MFA_PENDING,
  payload: { preAuthToken, mfaEnrolled },
});

/** Dispatched after a successful MFA verification / confirmation. */
export const mfaComplete = () => ({
  type: MFA_COMPLETE,
});
